import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { REGIONS } from "@/data/regions";
import { orgSchema, breadcrumb } from "@/lib/seo";
import { MapPin, ArrowRight } from "@phosphor-icons/react";

export default function Regions() {
  const { t, lang } = useI18n();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="regions-page">
      <Seo title={t("seo_regions_title")}
        description={t("regions_sub")} path="/regionen"
        jsonLd={[orgSchema(), breadcrumb([{ name: "Home", path: "/" }, { name: t("nav_regions"), path: "/regionen" }])]} />
      <p className="font-body text-sm text-[#EF5A1E] font-semibold mb-3">{t("nav_regions")}</p>
      <h1 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] leading-[1.05] max-w-3xl">{t("regions_title")}</h1>
      <p className="font-body text-[#5A607A] mt-5 text-lg max-w-2xl">{t("regions_sub")}</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-10">
        {REGIONS.map((r) => (
          <Link key={r.slug} to={`/regionen/${r.slug}`} data-testid={`region-${r.slug}`}
            className="group flex items-center justify-between gap-3 rounded-2xl border border-[#E9E5DE] bg-white px-5 py-4 hover:border-[#EF5A1E] transition-colors duration-200">
            <span className="flex items-center gap-2.5 font-body text-sm text-[#0B1533]">
              <span className="w-7 h-7 rounded-md bg-[#EEF1FF] text-[#EF5A1E] text-[10px] font-body font-bold flex items-center justify-center">{r.code}</span>
              {(r[lang] || r.de).name}
            </span>
            <ArrowRight size={16} className="text-[#9CA0B0] group-hover:text-[#EF5A1E] group-hover:translate-x-1 transition-all duration-200" />
          </Link>
        ))}
      </div>
    </div>
  );
}
